import React from 'react';
import { Container} from 'react-bootstrap';
import Banner1 from '../components/banner1';
import Features from '../components/features.js';
import CTA1 from '../components/cta1.js';
import Guidingprinciples from '../components/guidingprinciples';
import Addresscontact from '../components/addresscontact';
import SEO from '../components/SEO';

import { guidingPrinciples } from './data.js'; // Extracted data
import HomeBanner from '../components/homebanner.js';

const Home = () => {
  // Schema.org structured data for homepage
  const homeSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Robomec Automation - Industrial Machinery & Automation Solutions",
    "description": "Innovative automation solutions engineered for excellence. Specialists in robotic welding systems, thermal cutting systems, and material handling solutions.",
    "url": "https://www.robomecautomation.com",
    "mainEntity": {
      "@type": "Organization",
      "name": "Robomec Automation Private Limited",
      "description": "Leading manufacturer of industrial automation machinery and solutions"
    }
  };

  return (
    <>
      <SEO 
        title="Home"
        description="Robomec Automation specializes in designing and manufacturing high-quality industrial machinery, including robotic welding systems, thermal cutting systems, and material handling solutions."
        canonicalUrl="https://www.robomecautomation.com"
        keywords={[
          "industrial automation",
          "robotic welding systems",
          "thermal cutting systems",
          "material handling solutions",
          "automation machinery",
          "industrial machinery manufacturer"
        ]}
        schema={homeSchema}
      />
      <Container fluid>
        {/* Hero Section */}
        <HomeBanner />

        {/* Banner Section */}
        <Banner1 heading1="Innovative Automation, Engineered for Excellence" />

        {/* Features Section */}
        <Features
          features={[
            { title: 'Robotic Welding Systems', description: 'Achieve unmatched precision and quality.' },
            { title: 'Thermal Cutting Systems', description: 'High-performance cutting for intricate applications.' },
            { title: 'Material Handling Solutions', description: 'Streamline operations and enhance productivity.' },
          ]}
        />

        {/* Call to Action */}
        <CTA1 />

        {/* Guiding Principles */}
        <Guidingprinciples principles={guidingPrinciples} />

        {/* Testimonials removed for now */}
        {/* <Testimonials testimonials={testimonials} /> */}

        {/* Address and Contact */}
        <Addresscontact
          heading1="Contact Us"
          location2="Headquarters"
          location2Description="Robomec Automation Private Limited, B133, Opp Sukrut Company, Near Bharat Petroleum Pump, Bhambholi, Chakan, Pune 410501, INDIA"
        />
      </Container>
    </>
  );
};

export default Home;
